import { Injectable } from '@angular/core';

@Injectable()
export class WindowWrapperService {
  public get nativeWindow(): Window {
    return this.windowWrapper();
  }

  public isInIframe(): boolean {
    const { self, top } = this.nativeWindow;

    return self !== top;
  }

  private windowWrapper(): Window {
    return window;
  }
}
